// Generate MongoDB-compatible ObjectId (24-character hex string)
const generateObjectId = () => {
  const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
  const randomPart = Array.from({ length: 16 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join('');
  return (timestamp + randomPart).padEnd(24, '0').substring(0, 24);
};

export default generateObjectId;
